import { CardHeader, CardTitle } from '@/components/ui/card';

type Props = {
  title: string;
  description?: string;
  action: React.ReactNode;
};

const CardHeaderWithAction = ({ title, description, action }: Props) => {
  return (
    <CardHeader>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-6">
        <div className="grow space-y-1">
          <CardTitle className="text-lg">{title}</CardTitle>
          {description && <p className="text-sm text-muted-foreground">{description}</p>}
        </div>
        <div className="shrink-0">{action}</div>
      </div>
    </CardHeader>
  );
};

export default CardHeaderWithAction;
